<div>
  <h2 class="content-block">Abone Listesi</h2>
  
  <div
  class="buttons-container"
  style="
      display: flex;
      justify-content: end;
      right: 45px;
      position: fixed;
      top: 80px;
      z-index: 2;
    "
  >
    <p>Şablon Seçiniz :</p>
    <dx-select-box
      [dataSource]="templateNames"
      [(value)]="templateName"
      [inputAttr]="{ 'aria-label': 'Series Type' }"
    >
    </dx-select-box>
    <div class="buttons" id="code-buttons">
      <dx-button
        icon="save"
        type="success"
        text="Mail Yolla"
        class="margin"
        (onClick)="sendSubscriberMail()"
      ></dx-button>
    </div>
  </div>
  <dx-data-grid
    #dataGrid1
    [dataSource]="subscribers"
    class="content-block card responsive-paddings"
    keyExpr="id"
    (onRowUpdating)="updateSubscribe($event)"
    (onSelectionChanged)="onSelectionChanged($event)"
  >
  <dxo-selection mode="multiple"></dxo-selection> 
    <dxo-editing
      mode="row"
      [allowUpdating]="true"
      [allowDeleting]="false"
      [allowAdding]="false"
    >
    
    </dxo-editing>
    
    <dxo-export [enabled]="false"></dxo-export>
    <dxi-column
      dataField="rowNumber"
      [caption]="'#'"
      cellTemplate="rowNumberTemplate"
      [width]="50"
      [allowFiltering]="false"
      [allowEditing]="false"
    >
    </dxi-column>

    <dxi-column dataField="email" caption="Mail" [allowEditing]="true">
    </dxi-column>
    <dxi-column
      dataField="isSubscriber"
      caption="Abonelik Durumu"
      [allowEditing]="true"
    >
    </dxi-column>
    <div
      *dxTemplate="let cellInfo of 'rowNumberTemplate'"
      class="name-template"
    >
      <div>
        {{ getRowNumber(cellInfo.rowIndex) }}
      </div>
    </div>
  </dx-data-grid>
</div>
